<template>
    <div>
      <navbarreserve/>
       
      <modifydatetime/>
      <br>
      <!--  -->
      <mainfooter/>
    </div>
</template>

<script>
import mainfooter     from '@/components/mainfooter.vue'
import modifydatetime from '@/components/modifydatetime.vue'
import navbarreserve  from '@/components/navbarreserve.vue'

export default {
    name: 'ReserveDateTime',
    metaInfo: {
      title: "Enterprise Panama - Fecha Reserva | Alquiler de Autos",
      meta: [
        {
          vmid: 'A',
          name: 'description',
          content: 'Arriendo de vehiculos en Panamá. Empresa dedicada al arriendo de vehículos en Panamá, entre otros: automoviles, camionetas, van.',
        },
        {
          vmid: 'B',
          name: 'keywords',
          content: 'Enteprise panama, Enterprise rent a car, enterprise renta car, ALAMO, ENTERPRISE PANAMA, ALAMO PANAMA'
        }
      ]
    },
    components: {
        mainfooter,
        navbarreserve,
        modifydatetime
    }
}
</script>

<style lang="scss" scoped>
@font-face {
    font-family: 'DIN 2014-ExraBold';
    src: url('../assets/fonts/DIN2014-ExtraBold.ttf');

}
@font-face {
    font-family: 'DIN 2014-Regular';
    src: url('../assets/fonts/DIN2014-Regular.ttf');
}
.navbg{
    background-color: #f3f3f3;
}
.titlequestion{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 32px;
   margin-top: 15px;
   margin-left: 30px;
   font-weight: 800;
   color: #181918;
}
.navtext{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #169a5a !important;
    font-size: 14.5px;
    font-weight: 500 !important;
    margin: 0 !important;
    padding:0 !important;
    letter-spacing: 1.1px
}
.dinregular{
  font-family: 'DIN 2014-Regular';
}
.dinbold{
  font-family: 'DIN 2014-ExraBold';
}
.titleterm{
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 18px;
   margin-top: 15px;
   margin-left: 0px;
   font-weight: 500;
   color: #333333;
}
.navtext2{
    font-family: 'DIN 2014-Regular', Arial, sans-serif;
    color: #686e6b !important;
    font-size: 14px;
    font-weight: 300;
}
.titlenav{
   color: #333333; 
   font-family: 'DIN 2014-ExraBold', Arial, sans-serif;
   font-size: 14px;
   font-weight: 700;
   height: 19px;
   line-height: normal;
   margin: 0px 0px 5px;
   padding: 0px;
   width: 297px;
   letter-spacing: 1px
}


</style>